import AlertsLoader from '@shared/components/loading/AlertsLoader';
import SplashLoader from '@shared/components/loading/SplashLoader';
import { MAIN_CONTENT_ID } from '@shared/constants/ContentIdValues';
import { IMenuItem } from '@shared/models/components/IMenuProps';
import { useTranslation } from 'react-i18next';
import MenuSidebar from '../menu/MenuSidebar';
import { BodyHeaderWrapper, BodyLayout, BodyMainContent, BodyPageContent } from './CommonBodyLayoutStyles';
import ScrollToTop from './ScrollToTop';
import SkipToMain from './SkipToMain';

interface ISidebarLayoutProps {
    isLoading: boolean;
    headerContent: React.ReactNode;
    topItems: IMenuItem[];
    bottomItems: IMenuItem[];
    managed?: boolean;
    offset?: number;
    children?: React.ReactNode;
    prefixComponent?: React.ReactNode;
}

export default function SidebarLayout({
    isLoading,
    headerContent,
    topItems = [],
    bottomItems = [],
    managed = false,
    children,
    offset = 0,
    prefixComponent,
}: ISidebarLayoutProps) {
    const { t } = useTranslation();

    return (
        <BodyLayout $offset={offset}>
            <SkipToMain scrollToId={MAIN_CONTENT_ID} />
            <BodyHeaderWrapper>{headerContent}</BodyHeaderWrapper>
            <BodyPageContent>
                <AlertsLoader />
                {isLoading ? (
                    <SplashLoader text={t('common:authenticating')} refreshButton />
                ) : (
                    <>
                        <MenuSidebar
                            topMenuItems={topItems}
                            bottomMenuItems={bottomItems}
                            prefixComponent={prefixComponent}
                        />
                        <BodyMainContent id={MAIN_CONTENT_ID} tabIndex={-1} data-managed={!!managed}>
                            <ScrollToTop />
                            {children}
                        </BodyMainContent>
                    </>
                )}
            </BodyPageContent>
        </BodyLayout>
    );
}
